jQuery(document).ready(function () {
	const resources = document.querySelectorAll('.SingleResource');
	const searchSourceList = [];
	if (resources != null) {
		resources.forEach((resource) => {
			const content = resource.querySelector('.SingleResource-content').textContent.trim();
			const title = resource.querySelector('.SingleResource-title').textContent.trim();
			const blob = (title + ' ' + content).toLowerCase();
			searchSourceList.push({
				resource,
				blob,
				title,
			});
		});
	}

	jQuery('#resourcesearch').autocomplete({
		delay: 300,
		source: (request, response) => {
			const matches = [];
			searchSourceList.forEach((listItem) => {
				if (listItem.blob.indexOf(request.term.toLowerCase()) != -1) {
					matches.push(listItem.title);
				}
			});
			response(matches);
		},
		select: (event, selected) => {
			const title = selected.item.value;
			searchSourceList.some((sourceObject) => {
				if (sourceObject.title == title) {
					sourceObject.resource.setAttribute('open', '');
					$('html, body').animate(
						{ scrollTop: jQuery(sourceObject.resource).offset().top - 10 },
						600
					);
					return true;
				}
			});
		},
	});
});
